import React from "react";

/**
 * Delegate a click to a single <a> inside the clicked element.
 * Preserves modifier keys (ctrl/meta/shift) for new-tab behavior.
 */
export const delegateClickToLink = (event: React.MouseEvent) => {
    // Don't hijack clicks when user is selecting text
    if (window.getSelection()?.toString()) return;
    // Don't hijack clicks on cards with video
    if (event.currentTarget.querySelector("video")) return;
    // aria-hidden thing created with TwoUpCard's measure ref in mind, but
    // should be a reasonably generic thing to add
    const links = event.currentTarget.querySelectorAll(
        "a:not([aria-hidden] a)",
    );
    if (links.length !== 1) return;
    links[0].dispatchEvent(
        new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            ctrlKey: event.ctrlKey,
            metaKey: event.metaKey,
            shiftKey: event.shiftKey,
        }),
    );
};
